import { ServerConfig } from "@/config/config";
import { FrontendFunc } from "@/models/frontend-func";
import { Axios } from "./auth-service";

export class FrontendScriptsServiceClass {
	public readonly frontendSharedFuncsUrl:string = `${ServerConfig.mainAppHost}/frontend-shared-funcs`

	public async getFrontendSharedFuncs():Promise<FrontendFunc[]>{
		let result = await Axios.get(this.frontendSharedFuncsUrl);
		return result.data.map((f:any)=>new FrontendFunc(f));
	}

	public async getFrontendSharedFuncById(id:number):Promise<FrontendFunc>{
		let result = await Axios.get(`${this.frontendSharedFuncsUrl}/${id}`);
		return new FrontendFunc(result.data);
	}

	public async createFrontendSharedFunc(func:FrontendFunc):Promise<FrontendFunc>{
		let result = await Axios.post(`${this.frontendSharedFuncsUrl}`, func.getJSON());
		return new FrontendFunc(result.data);
	}

	public async updateFrontendSharedFunc(func:FrontendFunc):Promise<FrontendFunc>{
		let result = await Axios.put(`${this.frontendSharedFuncsUrl}/${func.ID}`, func.getJSON());
		return new FrontendFunc(result.data);
	}

	public async deleteFrontendSharedFunc(func:FrontendFunc):Promise<void>{
		await Axios.delete(`${this.frontendSharedFuncsUrl}/${func.ID}`);
	}
}

export const FrontendScriptsService = new FrontendScriptsServiceClass();